import React from 'react';
import * as date from "../util/date";

export default function Document(props) {

    const document = props.document;

    return (
        <div className="base-documentaire">
            <div className="col-xs-12 col-sm-6 col-md-4 highest views-row" style={{minHeight: "330px"}}>
                <article about="/node/52" className="documents documents-ressources clearfix">
                    <div className="panel panel-default highest" style={{minHeight: "332px"}}>
                        <div className="panel-heading professionnels">
                            <div>{document.title}</div>
                            <div className="panel-download">
                                <a target="_blank" title={document.title} rel="noopener noreferrer"
                                   href={document.url}>
                                    <i className="fa fa-download" aria-hidden="true"></i>
                                </a>
                            </div>
                        </div>
                        <div className="panel-body">
                            <div style={{marginRight: "1rem", textAlign: "right"}}
                                 className="mt-3 d-flex w-100 justify-content-end">
                                Date de dernière mise à jour : <br/> {date.formatDateTime(document.date, 'date')}
                            </div>
                            {document.themes.length ?
                                <>
                                    <h4>Thématiques</h4>
                                    <div className="d-flex mb-3 wrapper-thematique">
                                        <div className="field--items">
                                            {document.themes.split(', ')?.map((theme, index) => (
                                                <div key={index} className="thematique">
                                                    <div className="field--item">{theme}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                                : null
                            }
                        </div>
                    </div>
                </article>
            </div>

        </div>
    )
}